const baseStyle = {};
const defaultProps = {
    variant: 'default'
};
const parts = [
    'container',
    'account',
    'accountUserInfo',
    'content',
    'createAccount',
    'divider',
    'linkItem',
    'logo',
    'mainLinks',
    'mobileContent',
    'mobileToggle',
    'notifications',
    'services',
    'servicesMessage',
    'signIn'
];
const sizes = {};
const variants = {
    default: {
        container: {
            borderColor: 'darkBlue.main'
        },
        createAccount: {
            link: {
                variant: 'dark'
            }
        },
        linkItem: {
            container: {
                hoverBg: 'skyBlue.90',
                activeBg: 'transparent',
                activeBorderColor: 'darkBlue.main'
            },
            link: {
                size: 'lg',
                color: 'darkBlue.main',
                borderColor: 'darkBlue.main',
                hoverColor: 'darkBlue.main',
                activeColor: 'darkBlue.main'
            }
        },
        logo: {
            svg: {
                pathFill: '#0F204B' // darkBlue.main
            }
        },
        divider: {
            color: 'darkBlue.main'
        },
        mobileToggle: {
            color: 'darkBlue.main',
            hoverColor: 'darkBlue.main',
            activeColor: 'darkBlue.main'
        },
        notifications: {
            container: {
                color: 'darkBlue.main',
                hoverColor: 'darkBlue.main'
            }
        },
        services: {
            button: {
                color: 'darkBlue.main',
                hoverColor: 'darkBlue.main',
                activeColor: 'darkBlue.main'
            },
            list: {
                variant: 'blue'
            }
        },
        signIn: {
            background: 'darkBlue.main'
        }
    },
    dark: {
        container: {
            bg: 'darkBlue.main',
            borderBottom: 0
        },
        createAccount: {
            link: {
                variant: 'light'
            },
            text: {
                color: 'white'
            }
        },
        account: {
            trigger: {
                variant: 'primaryLight'
            }
        },
        divider: {
            borderColor: 'white'
        },
        linkItem: {
            container: {
                hoverBg: 'seaBlue.25',
                activeBg: 'transparent',
                activeBorderColor: 'digiGreen.main'
            },
            link: {
                size: 'lg',
                color: 'white',
                borderColor: 'digiGreen.main',
                hoverBg: 'seaBlue.25',
                hoverColor: 'white',
                activeBg: 'seaBlue.35',
                activeColor: 'white'
            }
        },
        logo: {
            svg: {
                pathFill: '#FFFFFF'
            }
        },
        mainLinks: {
            color: { md: 'white' }
        },
        mobileContent: {
            top: '100%'
        },
        mobileToggle: {
            color: 'white',
            hoverBg: 'seaBlue.25',
            hoverColor: 'white',
            activeBg: 'seaBlue.35',
            activeColor: 'white'
        },
        notifications: {
            container: {
                variant: 'solid',
                color: 'white',
                hoverBg: 'seaBlue.25',
                hoverColor: 'white',
                activeBg: 'seaBlue.35',
                borderColor: 'transparent'
            },
            icon: {
                color: 'white'
            }
        },
        services: {
            button: {
                color: 'white',
                hoverBg: 'seaBlue.25',
                hoverColor: 'white',
                activeBg: 'seaBlue.35',
                activeColor: 'white'
            },
            list: {
                variant: 'blue'
            }
        },
        signIn: {
            button: {
                variant: 'primaryLight'
            },
            colorScheme: 'pink'
        }
    }
};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
